const styles = theme => ({
  container: {},
  label: {
    color: theme.palette.primary.foreground,
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '21px',
    margin: '0',
  },
  list: {
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '8px',
  },
  listItem: {
    minWidth: 'auto',
    background: theme.palette.primary.white,
    color: theme.palette.secondary.dim,
    fontSize: '14px',
    fontWeight: '400',
    textTransform: 'capitalize',
    lineHeight: '150%',
    padding: '8px 16px',
    borderRadius: '30px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },

    '&:hover': {
      background: theme.palette.primary.white,
      color: theme.palette.secondary.dim,
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
  },
  listItemSelected: {
    background: theme.palette.primary.adgmHover,
    color: theme.palette.primary.white,
    // border: `1px solid ${theme.palette.secondary.dim}`,
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      // border: `1px solid ${theme.palette.secondary.dim}`,
    },
  },

  listItemSquare: {
    borderRadius: '8px',
  },

  listItemDisabled: {
    background: `${theme.palette.primary.darkGrey} !important`,
    color: `${theme.palette.primary.grey} !important`,
    border: '0 !important',
  },

  childrenContainer: {
    marginTop: '16px',
  },
});

export default styles;
